import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const drawLabel = async ({ orderId, basket, type, total, size }) => {
    const LABEL_WIDTH = 230
    const LABEL_HEIGHT = 170
    const qrDataUrl = await QRCode.toDataURL(orderId, { width: 200, margin: 3 })
    const qrDataImage = await _makeImage(qrDataUrl)
    const canvas = document.createElement('canvas')

    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT

    const ctx = canvas.getContext('2d')

    ctx.beginPath()
    ctx.rect(0, 0, 230, 170)
    ctx.fillStyle = 'white'
    ctx.fill()

    const qrWidth = LABEL_WIDTH / 2
    const qrY = LABEL_HEIGHT - qrWidth

    ctx.drawImage(qrDataImage, 0, qrY, qrWidth, qrWidth)

    ctx.fillStyle = 'black'
    ctx.font = '22px Arial'
    ctx.fillText(orderId, 12, 30)

    if(!!basket && !!total){
        ctx.beginPath()
        ctx.fillStyle = 'black'
        ctx.font = 'bold 25px Arial'
        ctx.fillText(`${basket}/${total}`, 125, 90)
    }

    if (['GIFTBOX_0700NO', 'GIFTCARD_1800NO', 'BOX_0700NO', 'THANK_CARD', 'BRAND_KIT'].includes(type)) {
        ctx.beginPath()
        ctx.fillStyle = 'black'
        ctx.font = 'bold 20px Arial'
        ctx.fillText(`${size}`, 125, 115)
    }

    ctx.beginPath()
    ctx.fillStyle = 'black'
    ctx.font = '22px Arial'
    ctx.fillText(type, 12, 55)

    return canvas.toDataURL()
}

export default drawLabel